
import { defineComponent, onBeforeMount, reactive } from 'vue'

import NewSelect from '@/ui-kit/NewSelect/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'

import crmAPI from '@/new-services/crm.service'
import { CrmSource } from '@/new-services/types/crm'
import useNotifications from '@/common/composable/useNotifications'

const TYPE_OPTIONS = [
    { name: 'Забор' },
    { name: 'Доставка' },
    { name: 'Незавершенный', value: '0' },
    { name: 'Завершенный', value: '1' },
]
const STATUS_OPTIONS = [
    { id: 47, name: 'В работе у КЦ' },
    { id: 48, name: 'Подтверджен' },
    { id: 49, name: 'Отказано' },
    { id: 61, name: 'Не дозвон' },
    { id: 71, name: 'Написали в WhatsApp' },
    { id: 72, name: 'Запрос у Менеджера' }
]

export default defineComponent({
    components: {
        NewSelect,
        NewButton,
        NewInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            invoiceNumber: null as string | null,
            waitListType: null as string | null,
            periodFrom: null as string | null,
            periodTo: null as string | null,
            processingStatusId: null as string | null,
            isCompleted: null as number | null,
            source: null as string | null,
        })

        const source_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as CrmSource[],
        })

        const onFiltersChanged = () => {
            if (props.disabled || props.loading) return
            const params = { ...state }
            if (params.isCompleted !== null) {
                params.waitListType = null
            }
            emit('submit', params)
        }

        const onFiltersReset = () => {
            state.invoiceNumber = null
            state.waitListType = null
            state.periodFrom = null
            state.periodTo = null
            state.processingStatusId = null
            state.source = null

            emit('reset')
        }

        const onUpdateType = (name: string) => {
            const option = TYPE_OPTIONS.find((item) => item.name === name)
            if (option && option.value) {
                state.isCompleted = Number(option.value)
            } else {
                state.isCompleted = null
            }
        }

        const loadSources = async () => {
            try {
                source_state.is_loading = true

                const response = await crmAPI.getSources()
                source_state.list = response.data.data
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении списка источников произошла ошибка',
                })
            } finally {
                source_state.is_loading = false
            }
        }

        onBeforeMount(loadSources)

        return {
            state,
            source_state,
            //
            onFiltersChanged,
            onFiltersReset,
            onUpdateType,
            loadSources,
            //
            TYPE_OPTIONS,
            STATUS_OPTIONS,
        }
    },
})
